// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
/* eslint-disable ta-code-conventions/require-jsdoc */

import React, { type Node, memo } from 'react';
import styles from './Switch.css';

type Props = {|
  label: Node,
  value: boolean,
  onChange: boolean => mixed,
|};

/**
 * An iOS-style switch control
 */
const Switch = ({ label, value, onChange }: Props) => (
  <label>
    <input
      className={styles.input}
      type="checkbox"
      checked={value}
      onChange={evt => onChange(evt.currentTarget.checked)}
    />
    <div className={styles.label}>
      <div className={styles.text}>{label}</div>
      <div className={styles.switch}>
        <div className={styles.knob} />
      </div>
    </div>
  </label>
);

export default memo<Props>(Switch);
